
const allLanguages = [
    {code: "en", title: "EN"},
    {code: "ru", title: "RU"}
]

export default allLanguages
